// STYLES
import * as Style from "./ButtonUploadAtomStyle";

// LIBRARIES
import { useDropzone } from "react-dropzone";

// MISC

// ASSETS
import UploadedImage from "assets/Icons/UploadedIcon.svg";

// REDUX

// COMPONENTS

const ButtonUpload = (props) => {
  // PROPS
  const { handleUploadFiles, onChange = "" } = props;

  // CONSTANTS USING LIBRARIES
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      handleUploadFiles([...acceptedFiles]);
    },
  });

  // CONSTANTS USING HOOKS

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS

  return (
    <Style.ButtonContainer {...getRootProps()}>
      <Style.Container>
        <Style.ImageContainer src={UploadedImage} alt="" />
        <Style.TextContainer>Adaugati fisiere</Style.TextContainer>
      </Style.Container>
      <Style.InputUploadContainer
        {...getInputProps()}
        hidden
        accept="image/*"
        multiple
        type="file"
        onChange={onChange}
      />
    </Style.ButtonContainer>
  );
};

export default ButtonUpload;
